import { ApolloCache } from '@apollo/client';
import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { FULL_MOMENT_FRAGMENT } from 'graphql/fragment/momentFragment';
import {
    WorldMapStories,
    WorldMapStoriesVariables
} from 'graphql/query/__generated__/WorldMapStories';
import { WORLD_MAP_STORIES } from 'graphql/query/worldQuery';

export const useDetailCache = (mapId: string) => {
    function addDetailListCache(cache: ApolloCache<unknown>, data: FFullMoment) {
        const c = cache.readQuery<WorldMapStories, WorldMapStoriesVariables>(
            {
                query: WORLD_MAP_STORIES,
                variables: { worldMapId: mapId }
            },
            true
        );
        if (c) {
            cache.updateQuery<WorldMapStories, WorldMapStoriesVariables>(
                { query: WORLD_MAP_STORIES, variables: { worldMapId: mapId } },
                (existing) => ({
                    publishedStoriesForWorldMap: [data, ...existing.publishedStoriesForWorldMap]
                })
            );
        }
    }

    function removeDetailListCache(cache: ApolloCache<unknown>, storyId: string) {
        const c = cache.readQuery<WorldMapStories, WorldMapStoriesVariables>(
            {
                query: WORLD_MAP_STORIES,
                variables: { worldMapId: mapId }
            },
            true
        );
        if (c) {
            cache.updateQuery<WorldMapStories, WorldMapStoriesVariables>(
                { query: WORLD_MAP_STORIES, variables: { worldMapId: mapId } },
                (existing) => ({
                    publishedStoriesForWorldMap: existing.publishedStoriesForWorldMap.filter(
                        (e) => e.storyId !== storyId
                    )
                })
            );
        }

        const removeId = cache.identify({
            __typename: 'PublishedStory',
            storyId
        });
        cache.evict({ id: removeId });
        cache.gc();
    }

    function updateDetailCache(cache: ApolloCache<unknown>, data: FFullMoment) {
        cache.updateFragment<FFullMoment>(
            {
                id: cache.identify({
                    __typename: 'PublishedStory',
                    storyId: data.storyId
                }),
                fragment: FULL_MOMENT_FRAGMENT
            },
            (oldData) => ({ ...oldData, ...data })
        );
    }

    return {
        addDetailListCache,
        removeDetailListCache,
        updateDetailCache
    };
};
